// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_modal-actions_12hyz_1p88p_5:not(#\\9){justify-content:flex-end}\n", ""]);
// Exports
module.exports = exports;
